export const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5003').replace(/\/+$/, '');

export const apiUrl = (path = '') => {
  const normalized = String(path || '').startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${normalized}`;
};


